import { useApiPost } from '../../api/Api.hooks';
import { StudyParticipant } from '../../models/StudyParticipant';

export function useWithdrawStudyParticipant(studyParticipantId: number) {
  const { data, isLoading, error, post } = useApiPost<StudyParticipant>(
    `study-participants/${studyParticipantId}/withdraw`
  );
  return {
    withdrawnStudyParticipant: data,
    withdrawingStudyParticipant: isLoading,
    withdrawingStudyParticipantError: error,
    withdrawStudyParticipant: post
  };
}
